<template>
	<pageCard v-if="isLoaded">
    	<uiheader
			:filters="filters"
			:options="options"
		/>
        <uifilters :misc="misc" :filters="filters"  @filters:changed="filterschanged" @filters:resetPage="resetpage" :options="options" @options:changed="optionschanged" :meta="meta" :loading="loading"/>
    	<uiElements :loading="loading" :elements="elements" :meta="meta" :filters="filters" @filters:changed="filterschanged" :options="options" @options:changed="optionschanged" @element:updated="elementsUpdated"/>
    	<uilistfooter class="bg-white" :hasElements="hasElements" :meta="meta" @pagechanged="changePage"/>
    </pageCard>
</template>

<script>

import uiCard from '@components/pages/elements/card'
import uilistfooter from '@components/ui/pagination/listfooter.vue'
import uiElements from './helpers/elements.vue'
import uiHeader from './helpers/header.vue'
import uifilters from './helpers/filters.vue'

export default {
	components : {
		'pageCard' : uiCard.card ,
		'pageCardBody' : uiCard.cardBody,
		'uiElements'  : uiElements,
        'uiheader'  : uiHeader,
        'uifilters' : uifilters,
		uilistfooter
	},

    props: {
    },
    watch: {
        options: {
            handler : function(value){
                this.get(1);
            },
            deep: true
        },
        filters: {
            handler : function(value){
            	if (!this.loading.status) {
					this.get(this.meta.current_page);
				}
            },
            deep: true
        },
    },
    data() {
		return {
            loading : {
            	status : false,
            	message : 'Loading ...',
            },
			isLoaded: false,
            elements: [],
            errors: [],
			misc: null,
            meta : {
                total : 0,
                per_page :  0,
                current_page : 1,
                last_page : 0,
                from :  0,
                to : 0
            },
            filters : {
                search : '',
                //category : '',
				//collection: '',
                status : '',
				created : {
					from : '',
					to : ''
				},
            },
            options : {
                per_page   : this.$store.getters['page/per_page'],
                order_by   : 'joinedAt',
                order_type : 'desc'
            },
		}
	},
    computed: {
    	isLoading : function () {
    		return this.loading.status
    	},
    	hasElements : function(){
            return this.elements.length > 0;
        },
        data(){
            return {
                options : this.options,
                filters : this.filters
            }
        },
	},
	created() {
		if (this.$route.params.page) {
			this.meta.current_page = parseInt(this.$route.params.page);
		}
	},
	mounted () {
        this.initialize();
    },
	methods : {
		initialize() {
			//If no filters is triggering the data load, do it manually
			this.loadConfig();
        },

		loadConfig : function(){
			this.$store.dispatch('users/misc')
					.then((response) => {
						this.misc = response.data;
						this.isLoaded = true;
						this.get(this.meta.current_page);
					})
					.catch( error => {
					});
		},
        changePage : function(page){
        	this.get(page);
        },
        optionschanged : function(options){
        	this.options = options;
        },
        filterschanged : function(filters){
            this.filters = filters;
        },
		resetpage : function(triggerGet = false){
			this.meta.current_page = 1;
			if (triggerGet) {
				this.get(this.meta.current_page);
			}
		},
        elementsUpdated : function(filters){
           this.get(this.meta.current_page);
        },

        get : function(page = 1){
			if (this.meta.current_page !== page) {
				this.$router.push({name: 'users-view-page', params: {page}})
			}
            this.loading.status = true;
            this.$store.dispatch('users/get', {...this.data, ...{page : page} })
            .then((response) => {
                this.loading.status = false;
                this.elements = response.data
                this.meta = response.meta
            })
            .catch( error => {
                this.loading.status = false;
                //this.errors = error.status.errors
            });
        },

    }
};
</script>
